<template>
  <div class="oem_package_card" :class="{ 'selected': isSelected }" @click="$emit('select', plan)">
    <h3>{{plan.name}}</h3>
    <h4 class="pricing">
      {{currencyIndicator}}{{oemPkg.quantity}}
    </h4>

    <span class="timerange">{{ $t('Monthly') }}</span>
  </div>
</template>
<script>
export default {
  name: 'OemPackageCard',
  props: {
    plan: {
      type: Object,
      required: true
      /**
       * Example of plan object:
       * {
       *           id: 2,
       *           name: "Business",
       *           oem_price: {
       *             quantity: "2200.00",
       *             currency: "USD"
       *           }
       *         },
       */
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    oemPkg() {
      return this.plan.oem_price || {};
    },
    currencyIndicator() {
      if (this.oemPkg.currency === 'USD') {
        return '$';
      } else if (this.oemPkg.currency === 'EUR') {
        return '€';
      } else if (this.oemPkg.currency === 'CNY') {
        return '¥';
      }
      return this.oemPkg.currency || '';
    }
  },
  emits: ['select'],
}
</script>
